export default "__VITE_PUBLIC_ASSET__5f6f7c69__"